// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LayoutSidebarRightOffOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 16 16","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M2 1L1 2v12l1 1h12l1-1V2l-1-1H2zm0 13V2h7v12H2zm8 0V2h4v12h-4z"}}]},"name":"layout-sidebar-right-off","theme":"outlined"};

const LayoutSidebarRightOffOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LayoutSidebarRightOffOutlinedSvg} />;
  LayoutSidebarRightOffOutlined.displayName = 'LayoutSidebarRightOffOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LayoutSidebarRightOffOutlined);
